import { Swiper } from "swiper/swiper-react";
import { Box, styled } from "@mui/material";

export const FunFactSectionContainer = styled(Box)({
    margin: "8px 0",
    display: "flex",
    width: "100%",
});

export const FunFactCard = styled(Box)({
    fontSize: "14px",
    lineHeight: 1.5,
    margin: 0,
    height: "100%",
    backgroundColor: "transparent",
    color: "var(--community-color-deep-atlantic-teal)",
    borderRadius: "8px",
    padding: "4px 8px 4px 4px",
});

export const FunFactsStyledSwiper = styled(Swiper)({
    padding: "16px 0",
    overflow: "hidden",

    ".swiper-button-disabled": {
        color: "transparent",
    },
    ".swiper-button-prev:after": {
        content: "none",
    },
    ".swiper-button-next:after": {
        content: "none",
    },
    ".swiper-slide:not(.swiper-slide-active) > div": {
        opacity: "0",
    },
});
